export function updateFewGridCardsClasses($grid, cardSelector = ".team-member") {
	if (!$grid || !$grid.length) {
		return;
	}

	var visibleCount = $grid.find(cardSelector + ":not(.is-hidden)").length;

	$grid.toggleClass("has-few-cards--tablet", visibleCount >= 1 && visibleCount <= 2);
	$grid.toggleClass("has-few-cards--desktop", visibleCount >= 1 && visibleCount <= 4);
}
